import { render, staticRenderFns } from "./StandardButton.vue?vue&type=template&id=5274ded5&"
import script from "./StandardButton.vue?vue&type=script&lang=ts&"
export * from "./StandardButton.vue?vue&type=script&lang=ts&"
import style0 from "./StandardButton.vue?vue&type=style&index=0&id=5274ded5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports